import type { State } from "../../types";

export type Selector<S> = (state: State) => S;

export const userIdSelector = (state: State) => state.application.user?.user_id;

export const userSelector = (state: State) => state.application.user;

export const tokenSelector = (state: State) => state.application.token;

export const isLoadingUserDataSelector = (state: State) =>
  state.application.isLoadingUserData;
